import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import {
  siteBoxDocumentsKeys,
  RequestTypes,
} from '@core/react-query/features/siteBoxDocuments'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import {
  ISiteBoxDocumentVersionBase,
  SiteBoxDocumentVersionBase,
} from '@core/entities/SiteBoxDocumentVersionBase'

const dataTransformer = (response: ISiteBoxDocumentVersionBase) =>
  SiteBoxDocumentVersionBase.new(response)

export const useGetSiteBoxDocumentByVersionId = (
  payload: RequestTypes['getSiteBoxDocumentVersion'],
  options?: UseQueryOptions<
    ISiteBoxDocumentVersionBase,
    RequestErrorType,
    SiteBoxDocumentVersionBase
  >,
) => {
  return useQuery({
    ...siteBoxDocumentsKeys.byVersionId(payload),
    select: dataTransformer,
    ...options,
  })
}
